import React from 'react';
import {FormattedMessage} from 'react-intl';
import {observer} from 'mobx-react';
import {auth, withState, t} from 'shared/core';
import SubNav from 'company_settings/SubNav';
import {Panel, Toggle, Layout} from 'components';
import HRDashboardVisibilityState from '../state/HRDashboardVisibilityState';

const PreferenceToggle = ({enabled, onChange, message}) => {
  return (
    <div>
      <div className='table-cell align-middle'>
        <Toggle enabled={enabled} onChange={value => onChange(value)}/>
      </div>
      <div className='table-cell align-middle pl2'>
        <FormattedMessage id={message}/>
      </div>
    </div>
  );
};

const HRDashboardVisibilityContainer = observer(({uiState}) => {
  const {company} = uiState;

  return (
    <div>
      <SubNav title={t('company_settings.subnav.Visibility Preferences')} toolbar={
        <div className='inline-block'>
        </div>
      }/>
      <Layout>
        <Panel.Stack loose>
          <Panel>
            <Panel.Header title={t('company_settings.hr_dashboard_visibility.Home Page Visibility Preferences')} />
            <div className='mb2'>
              <PreferenceToggle enabled={company.staffCountVisibility} onChange={value => uiState.updateStaffCountVisibility(value)} message='company_settings.hr_dashboard_visibility.Display staff breakdown on the home page.'/>
            </div>
            <div className='mb2'>
              <PreferenceToggle
                enabled={company.peopleOffTodayVisibility}
                onChange={value => uiState.updatePeopleOffTodayVisibility(value)}
                message={auth.company.slackEnabled ?
                  'company_settings.hr_dashboard_visibility.Display people off today on the home page and in Slack.' : 'company_settings.hr_dashboard_visibility.Display people off today on the home page.'
                }
              />
            </div>
          </Panel>
          <Panel>
            <Panel.Header title={t('company_settings.hr_dashboard_visibility.Feed Visibility Preferences')} />
            <div className='mb2'>
              <PreferenceToggle enabled={company.birthdayCelebrationVisibility} onChange={value => uiState.updateBirthdayCelebrationVisibility(value)} message='company_settings.hr_dashboard_visibility.Display employee birthdays on the home page feed.'/>
            </div>
            <div className='mb2'>
              <PreferenceToggle enabled={company.startDateCelebrationVisibility} onChange={value => uiState.updateStartDateCelebrationVisibility(value)} message='company_settings.hr_dashboard_visibility.Display employee start dates on the home page feed.'/>
            </div>
            <div className='mb2'>
              <PreferenceToggle enabled={company.anniversaryCelebrationVisibility} onChange={value => uiState.updateAnniversaryCelebrationVisibility(value)} message='company_settings.hr_dashboard_visibility.Display employee work anniversaries on the home page feed.'/>
            </div>
          </Panel>
        </Panel.Stack>
      </Layout>
    </div>
  );
});

export default withState(HRDashboardVisibilityContainer, HRDashboardVisibilityState);
